import {
  Button,
  Card,
  Col,
  Input,
  Result,
  Row,
  Typography,
  Select,
  Space,
  Table,
  message,
  DatePicker,
  Tooltip,
  Spin,
  Tabs,
} from "antd";
import moment, { Moment } from "moment";
import * as React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ErrorLog } from "../../models/error-log-interface";
import { CustomerServiceQueries } from "../../queries/customer-service-queries";
import { ErrorLogQueries } from "../../queries/error-log-queries";
import {
  GetDateFormateStr,
  TimeFromDate,
  TimeWithTimeZone,
} from "../../utilites/dateTimeHelper";
import { HasRight, Rights } from "../../utilites/auth";
import CPQAccessTab from "./tabs/CPQAccessTab";
import CPQProductsTab from "./tabs/CPQProductsTab";
import CPQFeatureTab from "./tabs/CPQFeatureTab";
import CPQWebhookTab from "./tabs/CPQWebhookTab";

const { Title } = Typography;
const { Option } = Select;

function CPQLogPage() {
  const [numDays, setNumDays] = useState(30);

  const filterSelect = (
    <Select
      value={numDays}
      onSelect={(val) => setNumDays(val)}
      style={{ width: 150 }}
    >
      <Option key={'30'} value={30}>
        30 Days
      </Option>
      <Option key={'60'} value={60}>
        60 Days
      </Option>
      <Option key={'90'} value={90}>
        90 Days
      </Option>
      <Option key={'0'} value={0}>
        All Time
      </Option>
    </Select>
  )

  return (
    <>
      {!HasRight([Rights.CSAdmin]) ? (
        <span>You do not have access to view this page.</span>
      ) : (
        <Spin spinning={false}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Row gutter={[16, 16]}>
                <Col flex={'auto'}>
                  <Title level={3}>CPQ Sync Logs</Title>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Tabs style={{ marginLeft: 10 }} tabBarExtraContent={filterSelect}>
                <Tabs.TabPane tab="Access" key="access">
                  <Row gutter={[16, 16]}>
                    <CPQAccessTab numDays={numDays} />
                  </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Products" key="products">
                  <Row gutter={[16, 16]}>
                    <CPQProductsTab numDays={numDays} />
                  </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Feature" key="feature">
                  <Row gutter={[16, 16]}>
                    <CPQFeatureTab numDays={numDays} />
                  </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Webhook" key="webhook">
                  <Row gutter={[16, 16]}>
                    <CPQWebhookTab numDays={numDays} />
                  </Row>
                </Tabs.TabPane>
              </Tabs>
            </Col>
          </Row>
        </Spin>
      )}
    </>
  );
}

export default CPQLogPage;
